import { render, staticRenderFns } from "./left-center.vue?vue&type=template&id=33a8f66e&scoped=true"
import script from "./left-center.vue?vue&type=script&lang=js"
export * from "./left-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8f66e",
  null
  
)

export default component.exports